import Vue from "vue";

import currencyService from "../services/currency.service";

Vue.filter("currency", function (sourceAmount, currencyId) {
  return currencyService.format(sourceAmount, currencyId);
})



// WEBPACK FOOTER //
// ./src/filters/currency.filter.js